import { Grid, Typography } from "@mui/material";

import { DisplayCurrency } from "src/components";

interface CommissionStatProps {
    label: string;
    value: number;
}

const CommissionStat = ({ label, value }: CommissionStatProps) => {
    return (
        <Grid
            md={6}
            sx={{
                display: 'flex',
                placeItems: 'center',
                flexDirection: 'column',
            }}
        >
            <Typography data-testid="commission-stat-label">{label}</Typography>
            <Grid
                sx={{ display: 'flex', flexDirection: 'row', padding: '4px' }}
                alignItems="center"
                gap={1}
            >
                <DisplayCurrency
                    centsAmount={value}
                    localeLanguage={navigator.language}
                    style={{ fontSize: '24px', fontWeight: 500, color: '#575757' }}
                />
            </Grid>
        </Grid>
    );
};
export default CommissionStat;
